import { GET, POST } from './Httpr.js';



export async function getAllLecturesByModuleId(request){
    let url = "lectures/getByModule";
    let requestData = {
        id_module: request
    }

    let rsp = await GET(url, requestData);

    return rsp;
}


export async function setLectureScoreView(request){
    let url = "lectures/setScore";
    let requestData = {
        id: request
    }

    let rsp = await POST(url, requestData);

    return rsp;
}